import React from "react";
import Newsletter from "../shared/Newsletter";
import { Container, Row, Col } from "reactstrap";
import "./../styles/terms-of-use.css";
import AchievementsSection from "../shared/AchievementsSection";

const TermsOfUse = () => {
  return (
    <>
      <section>
        <Container>
          <Row>
            <div>
              <div className="terms">
                <h1>Terms of Use</h1>
                <p>Effective Date: October 09, 2023</p>
              
              <p>Website Covered: <a href="https://therusticpaths.com">https://therusticpaths.com</a></p>
              <h2>THE AGREEMENT</h2>
              <p>
                The use of this website and services on this website provided by
                Private Drivers In India (hereinafter referred to as "Owner")
                are subject to the following Terms and Conditions (hereinafter
                the "Terms of Service"), all parts and sub-parts of which are
                specifically incorporated by reference here.
              </p>
              <p>
                Following are the Terms of Service governing your use of
                https://therusticpaths.com (the "Website"), all pages on
                the Website, and any services provided by or on this Website
                ("Services").
              </p>
              <p>
                By accessing, either directly or through a hyperlink, the
                website and/or purchasing something from us, you engage in our
                "service" and agree to be bound by the Terms of Service,
                including those additional terms and conditions and policies
                referenced herein and/or available by hyperlink. These Terms of
                Service apply to all users of the site, including, without
                limitation, vendors, buyers, customers, merchants, browsers,
                and/or contributors of content.
              </p>
              <h2>1) DEFINITIONS</h2>
              <p>
                The parties referred to in these Terms of Service shall be
                defined as follows:
              </p>
              <p>
                a) Owner, Us, and We: The owner, as the creator, operator, and
                publisher of the website, makes the website and certain services
                on it available to users. Private Drivers in India: Owner, Us,
                We, Our, Ours, and other first-person pronouns will refer to the
                owner, as well as all employees and affiliates of the owner.
              </p>
              <p>
                b) You, the User, the Client: You, as the user of the Website,
                will be referred to throughout these Terms of Service with
                second-person pronouns such as You, Your, Yours, or as User or
                Client. For the purpose of these Terms of Service, the term
                "user" or "you" shall mean any natural or legal person who is
                accessing the Website. The term 'your" shall be construed
                accordingly.
              </p>
              <p>
                c) Parties: Collectively, the parties to these Terms of Service
                (the Owner and You) will be referred to as Parties.
              </p>
              <h2>2) ASSENT & ACCEPTANCE</h2>
              <p>
                By using the website, you warrant that you have read and
                reviewed these terms of service and that you agree to be bound
                by them. If you do not agree to be bound by these terms of
                service, please leave the website immediately. The owner only
                agrees to provide use of this website and services to you if you
                assent to these terms of service. Further, based on the services
                obtained by a user, additional terms and conditions in respect
                of the specific services may apply, which shall be deemed an
                agreement between the user and the owner.
              </p>
              <h2>3) ABOUT THE SITE</h2>
              <p>
                The website is an online store that carries out sales of the
                following: drivers, guides, and tour packages.
              </p>
              <p>
                We reserve the right to refuse service or refuse to sell the
                products on the website at our sole discretion to anyone for any
                reason at any time.
              </p>
              <p>
                The website does not screen or censor the users who register on
                and access it. You assume all risks associated with dealing with
                other users with whom you come into contact through the website.
                You agree to use the website only for lawful purposes without
                infringing the rights of or restricting the use of this website
                by any third party.
              </p>
              <h2>4) LICENSE TO USE WEBSITE</h2>
              <p>
                The owner may provide you with certain information as a result
                of your use of the website or services.
              </p>
              <p>
                Such information may include, but is not limited to,
                documentation, data, or information developed by the owner, and
                other materials that may assist in your use of the website or
                services ("Owner Materials").
              </p>
              <p>
                Subject to these Terms of Service, the Owner grants You a
                non-exclusive, limited, non-transferable and revocable license
                to use the owner's materials solely in connection with your use
                of the website and services. The Owner Materials may not be used
                for any other purpose, and this license terminates upon your
                cessation of use of the Website or Services or at the
                termination of these Terms of Service.
              </p>
              <p>
                You agree not to collect the contact information of other users
                from the website or download or copy any information by means of
                unsolicited access so as to communicate directly with them or
                for any reason whatsoever.
              </p>
              <p>
                Any unauthorized use by you shall terminate the permission or
                license granted to you by the website, and You agree that you
                shall not bypass any measures used by the Owner to prevent or
                restrict access to the Website.
              </p>
              <h2>5) INTELLECTUAL PROPERTY</h2>
              <p>
                You agree that the website and all services provided by the
                owner are the property of the owner, including all copyrights,
                trademarks, trade secrets, patents, and other intellectual
                property ("Owner IP"). You agree that the owner owns all rights,
                title, and interest in and to the owner's IP and that you will
                not use the owner's IP for any unlawful or infringing purpose.
                You agree not to reproduce or distribute the Owner IP in any
                way, including electronically or via registration of any new
                trademarks, trade names, service marks, or Uniform Resource
                Locators (URLs), without express written permission from the
                Owner.
              </p>
              <p>
                a) In order to make the website and services available to you,
                you hereby grant the owner a royalty-free, non-exclusive,
                worldwide license to copy, display, use, broadcast, transmit,
                and make derivative works of any content you publish, upload, or
                otherwise make available to the website ("your content"). The
                owner claims no further proprietary rights to your content.
              </p>
              <p>
                b) If you feel that any of your intellectual property rights
                have been infringed on or otherwise violated by the posting of
                information or media by another of our users, please contact us
                and let us know.
              </p>
              <h2>6) USER OBLIGATIONS</h2>
              <p>
                As a user of the website or services, you may be asked to
                register with us. When you do so, you will choose a user
                identifier, which may be your email address or another term, as
                well as a password. You may also provide personal information,
                including, but not limited to, your name. You are responsible
                for ensuring the accuracy of this information. This identifying
                information will enable you to use the website and services. You
                must not share such identifying information with any third
                party, and if you discover that your identifying information has
                been compromised, you agree to notify us immediately in writing.
                Email notification will suffice. You are responsible for
                maintaining the safety and security of your identifying
                information as well as keeping us apprised of any changes to
                your identifying information. Providing false or inaccurate
                information, or using the website or services to further fraud
                or unlawful activity is grounds for immediate termination of
                these Terms of Service.
              </p>
              <p>
                a) You shall be responsible for all actions taken under your
                account. You agree to immediately notify the owner of any
                unauthorized use of your account or any other breach of
                security.
              </p>
              <p>
                b) As a user of the website or services, you agree to provide
                complete and accurate information about yourself when requested.
                You further confirm that you are the individual referred to in
                the provided information. In the event that any inaccurate or
                incomplete information is provided by you, the owner reserves
                the right to terminate your use of the website and services.
              </p>
              <h2>7) ACCEPTABLE USE</h2>
              <p>
                You agree not to use the website or services for any unlawful
                purpose or any purpose prohibited under this clause. You agree
                not to use the website or services in any way that could damage
                the website, services, or general business of the owner.
              </p>
              <p>
                a) You further agree not to use and/or access the website or
                services:
              </p>
              <p>
                i) To harass, abuse, or threaten others or otherwise violate any
                person's legal rights; ii) To violate any intellectual property
                rights of the owner or any third party; iii) To upload or
                otherwise disseminate any computer viruses or other software
                that may damage the property of another; iv) To perpetrate any
                fraud; v) To engage in or create any unlawful gambling,
                sweepstakes, or pyramid scheme; vi) To publish or distribute any
                obscene or defamatory material; vii) To publish or distribute
                any material that incites violence, hate, or discrimination
                towards any group; viii) To unlawfully gather information about
                others.
              </p>
              <h2>8) AFFILIATE MARKETING & ADVERTISING</h2>
              <p>
                The owner, through the website and services, may engage in
                affiliate marketing whereby the owner receives a commission on
                or a percentage of the sale of goods or services on or through
                the website. The owner may also accept advertising and
                sponsorships from commercial businesses or receive other forms
                of advertising compensation.
              </p>
              <p>
                a) This disclosure is intended to comply with the US Federal
                Trade Commission Rules on marketing and advertising, as well as
                any other legal requirements that may apply.
              </p>
              <p>
                b) Any testimonials or endorsements found on the website do not
                constitute a guarantee, warranty, or prediction regarding the
                outcome of your legal matter.
              </p>
              <h2>9) PRIVACY INFORMATION</h2>
              <p>
                Through your use of the website and services, you may provide
                the owner with certain information. By using the website or the
                services, you authorize the owner to use your information in the
                United States and any other country where the owner may operate.
              </p>
              <p>
                a) Information we may collect or receive: When you register for
                an account, you provide us with a valid email address and may
                provide us with additional information, such as your name or
                billing information. Depending on how you use our website or
                services, we may also receive information from external
                applications you use to access our website, or we may receive
                information through various web technologies, such as cookies,
                log files, clear gifs, web beacons, or others.
              </p>
              <p>
                b) How we use information: We use the information gathered from
                you to ensure your continued good experience on our website,
                including through email communication. We may also track certain
                of the passive information received to improve our marketing and
                analytics, and for this, we may work with third-party providers.
              </p>
              <p>
                c) How we share information: We may share information with third
                parties that perform services for us or on our behalf, including
                payment processing, data analysis, email delivery, hosting
                services, customer service, and marketing assistance.
              </p>
              <p>
                d) Emails and communication: We may contact you through email,
                telephone, or other electronic means. However, we will never
                send you marketing emails or solicitations without your consent.
                If you wish to unsubscribe from receiving electronic
                communications from us or our vendors, partners, or advertisers,
                you may do so at any time by clicking the "unsubscribe" link at
                the bottom of any emails you receive from us or by emailing the
                owner directly at info@therusticpaths.com.
              </p>
              <h2>10) DATA LOSS</h2>
              <p>
                The owner does not accept responsibility for the security of
                your account or content. You agree that your use of the website
                or services is at your own risk.
              </p>
              <p>
                a) The owner is not responsible for data loss resulting from:
                unauthorized access to or use of our servers; any interruption
                or cessation of transmission to or from the website or services;
                any bugs, viruses, or malware that may be transmitted to or
                through the website; any errors or omissions in any content or
                for any loss or damage incurred as a result of the use of any
                content posted, emailed, transmitted, or otherwise made
                available through the website or services.
              </p>
              <h2>11) INDEMNIFICATION</h2>
              <p>
                You agree to defend and indemnify the owner and any of its
                affiliates (if applicable) and hold us harmless against any and
                all legal claims and demands, including reasonable attorney's
                fees, which may arise from or relate to your use or misuse of
                the website or services, your breach of these Terms of Service,
                or your conduct or actions. You agree that the owner shall be
                able to select its own legal counsel and may participate in its
                own defense if the owner wishes.
              </p>
              <h2>12) SPAM POLICY</h2>
              <p>
                You are strictly prohibited from using the website or any of the
                owner's services for illegal spam activities, including
                gathering email addresses and personal information from others
                or sending any mass commercial emails.
              </p>
              <h2>13) THIRD-PARTY LINKS & CONTENT</h2>
              <p>
                The owner may occasionally post links to third-party websites or
                other services. You agree that the owner is not responsible or
                liable for any loss or damage caused as a result of your use of
                any third-party services linked to from our website.
              </p>
              <p>
                a) You understand that the owner does not endorse any of the
                products or services listed on our website.
              </p>
              <p>
                b) You understand that the owner does not provide any warranty
                or guarantee as to the accuracy, timeliness, performance,
                completeness, or suitability of the information and materials
                found on this website for any particular purpose.
              </p>
              <p>
                c) You acknowledge that such information and materials may
                contain inaccuracies or errors, and the owner expressly excludes
                liability for any such inaccuracies or errors to the fullest
                extent permitted by law.
              </p>
              <h2>14) DISCLAIMER OF WARRANTY</h2>
              <p>
                You agree that your use of the website and services is at your
                sole and exclusive risk and that any services provided by us are
                on an "As Is" basis. The owner hereby expressly disclaims any
                and all express or implied warranties of any kind, including,
                but not limited to the implied warranty of fitness for a
                particular purpose and the implied warranty of merchantability.
                The owner makes no warranties that the website or services will
                meet your needs or that the website or services will be
                uninterrupted, error-free, or secure. The owner also makes no
                warranties as to the reliability or accuracy of any information
                on the website or obtained through the services. You agree that
                any damage that may occur to you, through your computer system,
                or as a result of loss of your data from your use of the website
                or services is your sole responsibility and that the owner is
                not liable for any such damage or loss.
              </p>
              <p>
                a) You agree that the owner shall not be responsible for any
                damages suffered by you or any third party resulting from the
                use or inability to use the website or services or any of the
                information or materials contained therein.
              </p>
              <h2>15) LIMITATION OF LIABILITY</h2>
              <p>
                You agree that the owner shall not be liable for any damages
                whatsoever, including, but not limited to, any direct, indirect,
                incidental, consequential, or punitive damages arising out of
                the use of or inability to use the website or services or any
                information provided on the website or services. You further
                agree that the owner shall not be liable for any loss of
                profits, loss of business, or any indirect, special, or
                consequential damages of any kind resulting from the use of the
                website or services or any information or materials on the
                website or services.
              </p>
              <p>
                a) You agree that your use of the website and services is at
                your own risk and that the website and services are provided on
                an "As Is" and "As Available" basis.
              </p>
              <h2>16) TERMINATION OF SERVICE</h2>
              <p>
                The owner reserves the right to refuse service to anyone for any
                reason.
              </p>
              <p>
                The owner may terminate or suspend your access to the website
                and/or services immediately, without prior notice or liability,
                for any reason whatsoever, including, without limitation, if you
                breach these Terms of Service. Upon termination of your account,
                your right to use the website and services will immediately
                cease. If you wish to terminate your account, you may simply
                discontinue using the website and services.
              </p>
              <h2>17) ASSIGNMENT</h2>
              <p>
                You may not assign your rights and/or obligations under these
                Terms of Service to any other party without our prior written
                consent. We may assign our rights and/or obligations under these
                Terms of Service to any other party at our discretion.
              </p>
              <h2>18) GENERAL</h2>
              <p>You agree that:</p>
              <p>
                a) The owner shall be deemed solely based in California; and
              </p>
              <p>
                b) The website shall be deemed a passive website that does not
                give rise to personal jurisdiction over the owner, either
                specific or general, in jurisdictions other than California.
                These Terms of Service shall be governed by the internal
                substantive laws of the State of California, without respect to
                its conflict of laws principles. Any claim or dispute between
                you and the owner that arises in whole or in part from the
                website or services shall be decided exclusively by a court of
                competent jurisdiction located in Santa Clara County,
                California. These Terms of Service, together with the Privacy
                Policy and any other legal notices published by the owner on the
                website, shall constitute the entire agreement between you and
                the owner concerning the website and services. If any provision
                of these Terms of Service is deemed invalid by a court of
                competent jurisdiction, the invalidity of such provision shall
                not affect the validity of the remaining provisions of these
                Terms of Service, which shall remain in full force and effect.
                No waiver of any term of this these Terms of Service shall be
                deemed a further or continuing waiver of such term or any other
                term, and the owner's failure to assert any right or provision
                under these Terms of Service shall not constitute a waiver of
                such right or provision.
              </p>
              <p>
                c) Please contact us at info@therusticpaths.com with
                any questions regarding these Terms of Service.
              </p>
            </div>
            </div>
          </Row>
        </Container>
      </section>
      {/*--------------------------- Our Achievements Section Start--------------------------*/}
      <section>
        <Container>
          <Row>
            <Col lg="12">
              <div style={{ backgroundColor: "#ffffff" }}>
                <h2 align="center" className="services__subtitle">
                  Few of our achievements
                </h2>
              </div>
            </Col>
            <Col lg="12">
              <AchievementsSection />
            </Col>
          </Row>
        </Container>
      </section>

      {/*--------------------------- Our Achievements Section End--------------------------*/}
      <Newsletter />
    </>
  );
};

export default TermsOfUse;
